import script from "./UnidentifiedCoverageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnidentifiedCoverageCard.vue?vue&type=script&setup=true&lang=ts"

import "./UnidentifiedCoverageCard.vue?vue&type=style&index=0&id=5fb7b555&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb7b555"]])

export default __exports__